import { render, staticRenderFns } from "./BespokeDisclosureT1.vue?vue&type=template&id=1b9c6972&"
import script from "./BespokeDisclosureT1.vue?vue&type=script&lang=js&"
export * from "./BespokeDisclosureT1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports